import React from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import timesheet from '../../pages/Features/Timesheet/Timesheet.module.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { useTimesheetSummary } from '../../Hooks/Features/Timesheet/useTimesheetSummary';
import { SkeletonDataTable } from '../Loader/Loader';
import { dateConvert } from '../../utils/Helper';

function TimesheetSummary({ hoveredRange, filterValues, setFilterValues, tab, getData }) {

  const { columnDefs, onGridReady, rowData, onCellClicked, pinnedBottomRowData, showPopup, setShowPopup, tableHeaderData, tableData, columns, loader } = useTimesheetSummary({ hoveredRange, filterValues, setFilterValues, tab, getData });

  return (
    <div>
      {loader ? <SkeletonDataTable numSkeletons={20} /> :
        <div className="ts-container ag-theme-alpine" style={{ height: "calc(100vh - 110px)" }}>
          <AgGridReact rowHeight={28} columnDefs={columnDefs} suppressRowTransform={true} onGridReady={onGridReady} rowData={rowData} rowBuffer={200} onCellClicked={onCellClicked} pinnedBottomRowData={pinnedBottomRowData} />
        </div>
      }
      <div>
        {showPopup && (
          <div>
            <Dialog className='timesheet-dialog' modal={true} draggable={false} style={{ width: '86vw', minHeight: "50%" }} visible={showPopup} onHide={() => setShowPopup(false)} header={() => { return <div style={{ color: "inherit" }}><span style={{ fontWeight: "500" }}>{tableHeaderData.member_name} :</span>  {tableHeaderData.issue_type_name} - [{tableHeaderData.total_hours} h]</div> }}>
              <div className='timesheet-data-table'>
                <DataTable tableStyle={{ minWidth: '50%' }} value={tableData} scrollable scrollHeight="80vh" >
                  {columns?.map((col, i) => (
                    <Column key={col.field} field={col.field} header={col.header} body={col.field === "issue_key" ? (rowData) => { return <a href={rowData.issue_url} target='_blank' rel="noreferrer">{rowData.issue_key}</a> } : (col.field === "day_date" ? (rowData) => { return <>{dateConvert(rowData.day_date, "date")}</> } : "")} />
                  ))}
                </DataTable>
              </div>
            </Dialog>
          </div>
        )}
      </div>
    </div>
  )
}

export default TimesheetSummary